<div *ngIf="!isScheduleTimeDataLoaded || !isAppointmentDataLoaded || !appointments || isLoading"
     style="height: calc(100vh - 200px); width: 100vw; position: absolute; z-index: 3000;" data-cy="scheduling-loading">
  <app-tdo-progress-spinner data-cy="scheduling-spinner"></app-tdo-progress-spinner>
</div>
<div class="scheduler-main"
     style="overflow-x: hidden; width: 100%; height: 100%; display: flex; flex-direction: column;" data-cy="scheduling-container">
  <div *ngIf="viewType != 'dayDetailView'" style="flex: 1; overflow-y: hidden;" data-cy="scheduling-calendar-view">
    <dx-scheduler #tdoScheduler *ngIf="isScheduleTimeDataLoaded && isAppointmentDataLoaded && appointments"
                  [dataSource]="appointments" [views]="['day', 'week', 'workWeek', 'month']"
                  [showAllDayPanel]="false" (onAppointmentContextMenu)="onAppointmentContext($event)"
                  (onCellContextMenu)="onCellContextMenu($event)"
                  [startDayHour]="visibleStartHour" [endDayHour]="visibleEndHour" [currentDate]="tdoCurrentDate"
                  [currentView]="viewType"
                  [showCurrentTimeIndicator]='true' [cellDuration]="cellDuration" [crossScrollingEnabled]="true"
                  [shadeUntilCurrentTime]='true' [height]="'calc(100vh - 152px)'" [width]="'100%'"
                  [groups]="['Resource_OperatoryId']"
                  resourceCellTemplate="operatory_Template" appointmentTemplate="appointment_Template"
                  dataCellTemplate="dataCellTemplate" dateCellTemplate="dateCellTemplate"
                  timeCellTemplate="timeCellTemplate"
                  appointmentTooltipTemplate="tooltip_Template" (onContentReady)="onContentReady($event)"
                  (mouseup)="onMouseUp($event)" (onCellClick)="onCellClick($event);"
                  (onAppointmentClick)="onAppointmentClick($event)" (selectedCellDataChange)="onSelectingCells($event)"
                  (onAppointmentDblClick)="overrideDefaultPopup($event)"
                  (onOptionChanged)="onViewDateOptionChanged($event)"
                  (onAppointmentRendered) = "onZAppointmentRendered($event)"
                  (onAppointmentUpdated)="onAppointmentUpdatedDragDrop($event)" startDateExpr="StartDate"
                  endDateExpr="EndDate"
                  descriptionExpr="Description"
                  data-cy="scheduling-scheduler">

      <dxo-editing [allowAdding]="false" data-cy="scheduling-editing"></dxo-editing>

      <dxi-resource fieldExpr="Resource_OperatoryId" [allowMultiple]="false" [dataSource]="operatoryDataModels"
                    label="Operatory" data-cy="scheduling-resource">
      </dxi-resource>

      <div *dxTemplate="let op of 'operatory_Template'" data-cy="scheduling-operatory-template">
        <div [ngStyle]="{'backgroundColor': op.data.color != null ? op.data.color : 'var(--tdo-primary-accent'}"
             [style.width.pct]="100" style="border-top-left-radius: 8px; border-top-right-radius: 8px;" data-cy="scheduler-operatory">
          <div *ngIf="op.data.avatar" class="avatar" data-cy="scheduling-operatory-avatar">
            <img src="{{op.data.avatar}}" height="100%" width="100%" data-cy="scheduling-operatory-avatar-img"/>
          </div>
          <div class="calendar-column-header-text" style="color: white; font-size: 12px;" data-cy="scheduling-operatory-text">
            <div data-cy="scheduling-operatory-name">{{getLocationShortName(op.data)}}-{{op.data.OperatoryName}}</div>
            <div *ngIf="op.data.OperatoryDescription" data-cy="scheduling-operatory-description">{{op.data.OperatoryDescription}}</div>
          </div>
        </div>
      </div>
      <!---------------------------    NEW   --------------------------------------------------------------->
      <div *dxTemplate="let dataCell of 'dataCellTemplate'" [ngClass]="{
        'disable-date': isNonWorkingDay(dataCell.startDate) || isNotScheduledDay(dataCell.startDate),
        'breaktime': isBreakTime(dataCell.startDate)
        }" data-cy="scheduling-data-cell">
        <div style="height: 26px; width: 100%; z-index: -1000; opacity: 0.4;" data-cy="scheduling-data-cell-content">
          <div *ngIf="!isNonWorkingDay(dataCell.startDate)" [style.background-color]="getCellBackgroundColor(dataCell)"
               style="width: 100%; height: 100%;" data-cy="scheduling-data-cell-text">
            {{dataCell.text}}
          </div>
        </div>
      </div>

      <div *dxTemplate="let dateCell of 'dateCellTemplate'"
           [ngClass]="{ 'disable-date': isNotScheduledDay(dateCell.date) }" data-cy="scheduling-date-cell">
        {{dateCell.text}}
      </div>

      <div *dxTemplate="let timeCell of 'timeCellTemplate'"
           [ngClass]="{ 'breaktime': isBreakTimeColumn(timeCell.date) }" data-cy="scheduling-time-cell">
        {{timeCell.text}}
        <div *ngIf="hasCoffeeCupIcon(timeCell.date)" class="cafe" data-cy="scheduling-coffee-icon"></div>
      </div>
      <!---------------------------  END NEW   ------------------------------------------------------------->
      <div *dxTemplate="let appt of 'tooltip_Template'" data-cy="scheduling-tooltip-template">
        <div style="text-align: left;" (click)="stopPropegation($event)" data-cy="scheduler-tooltip">
          <div *ngIf="appt.appointmentData.isReservation" data-cy="scheduling-tooltip-reserved">
            This appointment slot has been reserved.<br/>This means that another user is entering<br/>details for this
            time and operatory.<br />
            Reserved by: {{getUser(appt.appointmentData.xauditCreatedBy)}}
          </div>
          <div *ngIf="!appt.appointmentData.isReservation" data-cy="scheduling-tooltip-appointment">
            <div data-cy="scheduling-tooltip-patient">Patient: <b>{{appt.appointmentData.PatientFullInfo | jsonParam:'FullName'}}</b></div>
            <div data-cy="scheduling-tooltip-subject">{{appt.appointmentData.Subject}}</div>
            <div style="display: flex;" data-cy="scheduling-tooltip-doctor-container">
              <div data-cy="scheduling-tooltip-doctor">Doctor: {{returnDoctorById(appt.appointmentData?.Label_DoctorId)?.dataContact.LastName}}</div>
              <div style="color: red; display: flex;" matTooltip="This doctor is inactive!"
                   *ngIf="!returnDoctorById(appt.appointmentData?.Label_DoctorId)?.isActiveDoctor" data-cy="scheduling-tooltip-inactive-doctor">
                <div style="opacity: 1; margin-left: 5px;" data-cy="scheduling-tooltip-inactive-text">(Inactive Doctor!)</div>
                <mat-icon style="position: relative; top: -4px;" data-cy="scheduling-tooltip-inactive-icon">report</mat-icon>
              </div>
            </div>
            <div *ngIf="appt.appointmentData && appt.appointmentData?.Procedure" data-cy="scheduling-tooltip-procedure">
              Procedure:
              <strong>{{appt.appointmentData?.Procedure?.ProcedureName}}</strong>
            </div>
            <div data-cy="scheduling-tooltip-referring">
              Ref
              Doctor: {{returnReferringDoctorById(appt.appointmentData, appt?.appointmentData.Referring_DoctorId)?.Description}}
            </div>
            <div data-cy="scheduling-tooltip-time">{{(appt.appointmentData.StartDate | date:'shortTime') + ' - ' + (appt.appointmentData.EndDate | date:'shortTime')}}</div>
            <button mat-button matTooltip="Tele Dentistry Call / Video Consultation" data-cy="scheduler-btn-videocall"
                    *ngIf="appt.appointmentData.enumApptTypeId==='00000071-0000-0000-0000-000000000004'"
                    (click)="onVCCallClick(appt.appointmentData.PatientFullInfo)">
              <mat-icon>video_call</mat-icon>
              <span> - Call</span>
            </button>
          </div>
        </div>
      </div>

      <div (mousedown)="appointmentMouseDown($event, appt.appointmentData)"
           style="width: 100%; display: flex; padding: 0;" *dxTemplate="let appt of 'appointment_Template'" data-cy="scheduler-appointment">
        <div
          style="pointer-events: none; background-color: var(--tdo-primary); color: white; position: relative; width: 100%;"
          *ngIf="appt.appointmentData.isReservation" data-cy="scheduling-appointment-reserved">
          <div
            style="position: relative; top: 50%; transform: translateY(-10px); width: 100%; text-align: center; font-weight: 500;" data-cy="scheduling-appointment-reserved-text">
            RESERVED
          </div>
        </div>
        <div
          style="pointer-events: none; color: white; position: relative; width: 100%;"
          *ngIf="isBlockAppt(appt.appointmentData)"
          [ngStyle]="{'background-color': getAppointmentMainBackgroundColor(appt?.appointmentData), 'color': getAppointmentMainForgroundColor(appt?.appointmentData)}" data-cy="scheduling-appointment-blocked">
          <div
            style="position: relative; top: 50%; transform: translateY(-10px); width: 100%; text-align: center; font-weight: 500;" data-cy="scheduling-appointment-blocked-text">
            BLOCKED
          </div>
        </div>
        <div style="display: flex; width: 100%;" *ngIf="!appt.appointmentData.isReservation && !isBlockAppt(appt.appointmentData)" data-cy="scheduling-appointment-normal">
          <div style="flex: 1;"
               [ngStyle]="{'background-color': getAppointmentMainBackgroundColor(appt?.appointmentData), 'color': getAppointmentMainForgroundColor(appt?.appointmentData)}" data-cy="scheduling-appointment-content">
            <div style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="scheduling-appointment-layout">
              <div
                style="flex-basis: 26px; max-height: 26px; width: 100%; padding-top: 4px; padding-bottom: 4px; display: flex;"
                [ngStyle]="{'background-color': getAppointmentTopBarBackgroundColor(appt?.appointmentData)}" data-cy="scheduling-appointment-topbar">
                <div style="flex: 1; display: flex;" data-cy="scheduling-appointment-patient-flags">
                  <!--PATIENT FLAGS-->
                  <img style="height: 20px; width: 20px; position: relative;"
                       *ngFor="let flag of appt.appointmentData.dataPatientFlags" [src]="getPatientFlagImage(flag)"
                       [matTooltip]="getPatientFlagTooltip(flag)" data-cy="scheduling-appointment-patient-flag"/>
                </div>
                <div style="flex: 1; display: flex; justify-content: flex-end;" data-cy="scheduling-appointment-appt-flags">
                  <!--APPOINTMENT FLAGS-->
                  <img style="height: 20px; width: 20px; position: relative;"
                       *ngFor="let flag of appt.appointmentData.dataAppoitmentFlags"
                       [src]="getAppointmentFlagImage(flag)" [matTooltip]="getAppointmentFlagTooltip(flag)" data-cy="scheduling-appointment-appt-flag"/>
                </div>
              </div>
              <div style="flex: 1; overflow-y: auto; padding-top: 3px; padding-left: 5px;" data-cy="scheduling-appointment-details">
                <div [ngStyle]="{'color': getAppointmentMainForgroundColor(appt.appointmentData)}" data-cy="scheduling-appointment-text">
                  <div style="font-weight: 500; font-size: 16px;"
                       *ngIf="appt.appointmentData.enumApptStatusId === '00000072-0000-0000-0000-000000000007'" data-cy="scheduling-appointment-canceled">Canceled
                  </div>
                  <div style="cursor:pointer; text-decoration: underline;"
                       (click)="changeToPatientAndGotoCaseView(appt.appointmentData);" data-cy="scheduling-appointment-patient">Patient:
                    <b>{{appt?.appointmentData?.PatientFullInfo | jsonParam:'FullName'}}</b></div>
                  <div data-cy="scheduling-appointment-subject">{{appt.appointmentData.Subject}}</div>
                  <div style="display: flex;" data-cy="scheduling-appointment-doctor-container">
                    <div data-cy="scheduling-appointment-doctor">
                      Doctor: {{returnDoctorById(appt?.appointmentData?.Label_DoctorId)?.dataContact?.LastName}}</div>
                    <div style="color: red; display: flex;" matTooltip="This doctor is inactive!"
                         *ngIf="!returnDoctorById(appt.appointmentData.Label_DoctorId)?.isActiveDoctor" data-cy="scheduling-appointment-inactive-doctor">
                      <div style="opacity: 1; margin-left: 5px;" data-cy="scheduling-appointment-inactive-text">(Inactive Doctor!)</div>
                      <mat-icon style="position: relative; top: -4px;" data-cy="scheduling-appointment-inactive-icon">report</mat-icon>
                    </div>
                  </div>
                  <div *ngIf="appt.appointmentData && appt.appointmentData.Procedure" data-cy="scheduling-appointment-procedure">
                    Procedure:
                    <strong>{{appt.appointmentData.Procedure.ProcedureName}}</strong>
                  </div>
                  <div data-cy="scheduling-appointment-referring">
                    Ref
                    Doctor: {{returnReferringDoctorById(appt.appointmentData, appt?.appointmentData.Referring_DoctorId)?.Description}}
                  </div>
                  <div data-cy="scheduling-appointment-time">{{(appt.appointmentData.StartDate | date:'shortTime') + ' - ' + (appt.appointmentData.EndDate | date:'shortTime')}}</div>
                  <button mat-button matTooltip="Tele Dentistry Call / Video Consultation" data-cy="scheduling-appointment-videocall"
                          *ngIf="appt.appointmentData.enumApptTypeId==='00000071-0000-0000-0000-000000000004'"
                          (click)="onVCCallClick(appt.appointmentData.PatientFullInfo)">
                    <mat-icon>video_call</mat-icon>
                    <span> - Call</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div style="flex-basis: 26px; height: 100%;"
               [style.background-color]="getAppointmentRightBarBackgroundColor(appt.appointmentData)"
               [style.color]="getAppointmentRightBarForgroundColor(appt.appointmentData)" data-cy="scheduling-appointment-rightbar">
            <div (click)="onOpenMedicalInformationFormDialog(appt.appointmentData); false;"
                 matTooltip="Appointment Medical Information"
                 style="margin-right: 2px; flex-basis: 26px; max-height: 26px; position: relative; top: -2px; border-radius: 3px; padding: 3px;" data-cy="scheduling-appointment-medical">
              <mat-icon style="position: relative; left: -2px;" class="rounded shadow-4" data-cy="scheduling-appointment-medical-icon">medical_information</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </dx-scheduler>

    <dx-context-menu [dataSource]="rightClickScheduleOptions" [width]="200" target=".dx-scheduler-date-table-cell"
                     (onItemClick)="ctxMenuItemClickCell($event)" [(visible)]="isCellContextMenuVisible" data-cy="scheduling-cell-context-menu">
    </dx-context-menu>
    <dx-context-menu [dataSource]="rightClickAppointmentOptions" [width]="200" target=".dx-scheduler-appointment"
                     (onItemClick)="ctxMenuItemClickApp($event)" [(visible)]="isAppContextMenuVisible" data-cy="scheduling-appointment-context-menu">
    </dx-context-menu>
  </div>
</div>
